module.exports = __webpack_public_path__ + "static/media/ai3.47abf315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/ai3.jpg
// module id = 54
// module chunks = 0